import AOS from 'aos';

AOS.init({
  offset: -100,
  duration: 600,
  easing: 'ease-out-cubic',
  once: true,
  anchorPlacement: 'top-center',
});
faq();

function faq() {
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const faqItems = document.querySelectorAll('#faq .faq-list__item');

  faqItems.forEach((item) => {
    item.addEventListener('click', () => {
      item.classList.toggle('is-reverse');
    });
  });
}
